// EXAMPLE_CODE
console.log('this is file src/js/index.js');

/**
 * Third Party JS
 */
import './packages/splittype.min';

/**
 * Custom JS
 */
import './animations';
// import './css-animation-polyfill';
// import './cursor_sticky';
import './details-content-reveal';
import './faq-schema';
// import './navigation';
import './slick-slide';
